import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Redirect, withRouter, NavLink} from 'react-router-dom'
import { signUp } from '../../../store/actions/authActions'; //../../../store/actions/authActions

//components
import { signInWithGoogle } from '../../../config/signInWithGoogle';
import GoogleButton from 'react-google-button';

//logo
import logo from '../../../images/bound_bleu_logo.png'

class SignUp extends Component {
  state = {
      email: '',
      password: '',
      firstName: '',
      lastName: '',
  }

  handleChange = (e) => {
      this.setState({
          [e.target.id]: e.target.value
      })
  }

  handleSubmit = (e) => {
      e.preventDefault();
      //this.props.signIn(this.state);
      if(this.state.email.includes("gmail")){
          signInWithGoogle()
      }else{
          this.props.signUp(this.state);
      }
  }

  render() {
      const { auth, authError } = this.props;
      if (auth.uid) return <Redirect to='/' />
    return (
      <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <img
            className="mx-auto h-12 w-auto"
            src={logo}
            alt="Bound"
          />
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">Sign up below to get started</h2>
          {/* <p className="mt-2 text-center text-sm text-gray-600">
            Or{' '}
            <a href="#" className="font-medium text-indigo-600 hover:text-indigo-500">
              start your 14-day free trial
            </a>
          </p> */}
        </div>
  
        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
          <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
            <form className="space-y-6" onSubmit={this.handleSubmit}>
                <div>
                    <label htmlFor="firstName" className="block text-sm font-medium text-gray-700">
                        First name
                    </label>
                    <div className="mt-1">
                    <input
                        id="firstName"
                        name="firstName"
                        type="text"
                        autoComplete="off"
                        required
                        className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        onChange={this.handleChange}
                    />
                    </div>
                </div>

                <div>
                    <label htmlFor="lastName" className="block text-sm font-medium text-gray-700">
                        Last name
                    </label>
                    <div className="mt-1">
                    <input
                        id="lastName"
                        name="lastName"
                        type="text"
                        autoComplete="off"
                        required
                        className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        onChange={this.handleChange}
                    />
                    </div>
                </div>

                <div>
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                    Email address
                    </label>
                    <div className="mt-1">
                    <input
                        id="email"
                        name="email"
                        type="email"
                        autoComplete="off"
                        required
                        className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        onChange={this.handleChange}
                    />
                    </div>
                </div>
  
              <div>
                <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                  Password
                </label>
                <div className="mt-1">
                  <input
                    id="password"
                    name="password"
                    type="password"
                    autoComplete="off"
                    required
                    className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                    onChange={this.handleChange}
                  />
                </div>
              </div>
  
              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  {/* <input
                    id="remember_me"
                    name="remember_me"
                    type="checkbox"
                    className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
                  />
                  <label htmlFor="remember_me" className="ml-2 block text-sm text-gray-900">
                    Remember me
                  </label> */}
                </div>
  
                <div className="text-sm">
                  <NavLink
                  className="font-medium text-indigo-600 hover:text-indigo-500"
                  exact
                  to='/signIn'
                  >
                      Already have an account
                  </NavLink>
                </div>
              </div>
  
              <div>
                <button
                  type="submit"
                  className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                  Sign up
                </button>
              </div>
            </form>
            <div>
              { authError ? <p style={{color: 'red', fontSize: '20px'}}> {authError} </p> : null }
            </div>
  
            <div className="mt-6">
              <div className="relative">
                <div className="absolute inset-0 flex items-center">
                  <div className="w-full border-t border-gray-300" />
                </div>
                <div className="relative flex justify-center text-sm">
                  <span className="px-2 bg-white text-gray-500">Or continue with</span>
                </div>
              </div>
  
              <div className="mt-6 grid grid-cols-3 gap-3">
                <div>
                  <GoogleButton 
                  type="dark" 
                  onClick={signInWithGoogle}
                  style={{
                    borderRadius: '3px',
                    backgroundColor: '#4F46E5',
                    color: 'white'
                  }}
                  />
                </div>
                <div></div>
                <div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
      auth: state.firebase.auth,
      authError: state.auth.authError
  }
}

const mapDispatchToProps = (dispatch) =>{
  return {
      signUp: (newUser)=>dispatch(signUp(newUser))
  }
}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(SignUp))
